import type { InboxMessage } from "../services/messageService"

// Older messages do not carry their kind, application type and reference as
// fields. They are read from the title, the link and the text instead.

export function messageKind(message: InboxMessage): InboxMessage["kind"] {
  if (message.kind) return message.kind
  if (message.title.startsWith("We have received")) return "received"
  if (message.title.startsWith("Your application has been filed")) return "filed"
  if (message.title.startsWith("Signed power of attorney")) return "power-of-attorney"
  return null
}

export function applicationTypeLabel(message: InboxMessage): "Trademark" | "Design" | "Patent" | null {
  const type =
    message.applicationType ??
    (message.link?.startsWith("/design-applications/")
      ? "design"
      : message.link?.startsWith("/patent-applications/")
        ? "patent"
        : message.link?.startsWith("/applications/")
          ? "trademark"
          : null)

  return type === "trademark" ? "Trademark" : type === "design" ? "Design" : type === "patent" ? "Patent" : null
}

// "Reference TM-1. We will now check it." -> "TM-1"
export function messageReference(message: InboxMessage): string | null {
  return message.reference ?? message.body.match(/^Reference (.+?)\./)?.[1] ?? null
}

export function dayLabel(value: string) {
  return new Date(value).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })
}

export function timeLabel(value: string) {
  return new Date(value).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
}

// Messages come newest first: neighbours of the same day form a group
export function groupByDay(messages: InboxMessage[]) {
  const groups: Array<{ label: string; items: InboxMessage[] }> = []

  for (const message of messages) {
    const label = dayLabel(message.createdAt)
    const last = groups[groups.length - 1]

    if (last && last.label === label) last.items.push(message)
    else groups.push({ label, items: [message] })
  }

  return groups
}
